import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="w-full px-6 py-20 md:py-32 bg-white text-center" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <div className="mb-12" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/gnUDfcn1Brw8kVEQFv5pr9/N1PIC1.png" alt="The 21 Day Perimenopause Belly Reset" className="w-full max-w-lg mx-auto rounded-lg shadow-2xl mb-12" data-id="element-98" />

            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-99">
              <span className="text-2xl font-serif text-stone-400 line-through" data-id="element-100">
                $19.99
              </span>
              <span className="text-5xl font-serif text-stone-800" data-id="element-101">$6.39</span>
              <span className="bg-terracotta/10 text-terracotta text-sm font-semibold px-3 py-1 rounded-full" data-id="element-102">
                68% OFF
              </span>
            </div>

            <p className="text-xl text-stone-600 mb-8 max-w-xl mx-auto leading-relaxed" data-id="element-103">
              You can start tonight. You can print the tracker tomorrow. You can
              do the first workout this week.
            </p>

            <p className="font-serif text-2xl text-terracotta italic mb-12" data-id="element-104">
              You do not need a new identity. You just need a better system.
            </p>

            <a href="https://simplepersonalgrowth.store/cart/44589493157933:1" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart');
            }
          }} className="inline-flex flex-col items-center justify-center px-10 py-5 bg-terracotta text-white font-medium rounded-full hover:bg-terracotta-dark transition-all duration-300 hover:scale-[1.02] shadow-xl shadow-terracotta/20 mb-8" data-id="element-105">
              <span className="inline-flex items-center text-xl mb-1" data-id="element-106">
                Get the PDF
                <ArrowRight className="ml-2 h-6 w-6" data-id="element-107" />
              </span>
              <span className="inline-flex items-center gap-1.5 text-sm" data-id="element-108">
                <span className="line-through opacity-60" data-id="element-109">$19.99</span>
                <span className="font-semibold" data-id="element-110">$6.39</span>
                <span className="bg-white/20 text-white text-xs font-semibold px-2 py-0.5 rounded-full" data-id="element-111">
                  68% OFF
                </span>
              </span>
            </a>

            <p className="text-stone-500 font-medium" data-id="element-112">
              Get the PDF. Run the locks. Feel your body cooperate again.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}